export const getDateStatus = (dateTime: number, workTime: number) => {
  const workTimeInDay = (workTime / 5) * 60;

  if (dateTime >= workTimeInDay) {
    return 'var(--light-success-color)';
  } else if (dateTime > 0) {
    return 'var(--light-info-color)';
  } else {
    return 'var(--light-secondary-color)';
  }
};
